import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  output,
  inject,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CouponService } from '@fitness-force/api';
import type { CouponEligibleClient, OfferMaster } from '@fitness-force/models';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ScrollPanelModule } from 'primeng/scrollpanel';

import { BehaviorSubject, Observable } from 'rxjs';
import { CouponEligibleClientsComponent } from '../../../../offer/coupon-eligible-clients/coupon-eligible-clients.component';
import { CouponOrganizationRestrictionComponent } from '../../../../offer/coupon-organization-restriction/coupon-organization-restriction.component';
import { CouponPlanRestrictionComponent } from '../../../../offer/coupon-plan-restriction/coupon-plan-restriction.component';
import { CouponServiceRestrictionComponent } from '../../../../offer/coupon-service-restriction/coupon-service-restriction.component';

@Component({
  selector: 'fitness-force-coupon-eligibility',
  templateUrl: './coupon-eligibility.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollPanelModule,
    ButtonModule,
    CouponEligibleClientsComponent,
    CouponServiceRestrictionComponent,
    CouponPlanRestrictionComponent,
    CouponOrganizationRestrictionComponent,
    TranslateModule,
    AsyncPipe,
  ],
})
export class CouponEligibilityComponent {
  private coupnService = inject(CouponService);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  readonly onAction = output<{ action: string; columnData?: any }>();

  tenantId = 0;
  couponMasterId = 0;
  couponMaster: OfferMaster;
  addClientsModal = new BehaviorSubject(false);
  addServicessModal = new BehaviorSubject(false);
  addPlansModal = new BehaviorSubject(false);
  addOrganisationModal = new BehaviorSubject(false);

  eligibleClients: CouponEligibleClient[] = [];
  selectedClients = new BehaviorSubject<CouponEligibleClient[]>([]);
  selectedServiceIds: number[] = [];
  selectedPlanIds: number[] = [];
  selectedOrganizationIds: number[] = [];


  GetClients(couponMaster: OfferMaster) {
    this.couponMaster = couponMaster;
    this.couponMasterId = couponMaster.id;
    this.tenantId = couponMaster.tenant_id;
    this.addClientsModal.next(true);
    // this.coupnService.getEligibleClients(couponMaster.tenant_id,couponMaster.id).subscribe({
    //   next: (response: any) => {
    //     this.eligibleClients = response.items as CouponEligibleClient[];
    //     let clients:CouponEligibleClient[]=[];
    //     this.eligibleClients.forEach (o => {
    //       let client:CouponEligibleClient={} as CouponEligibleClient;
    //       client.client_id = o.client_id;
    //       client.client_name = o.client_name;
    //       client.client_iamge = o.client_iamge;
    //       client.offer_master_id = o.offer_master_id;
    //       client.id = o.id;
    //       clients.push(client);
    //     });
    //     this.selectedClients.next(this.eligibleClients);
    //     this.addClientsModal.next(true);
    //   },
    //   error: (error: any) => {
    //   },
    // });
  }

  addServices(couponMaster: OfferMaster) {
    this.couponMaster = couponMaster;
    this.couponMasterId = couponMaster.id;
    this.tenantId = couponMaster.tenant_id;
    this.selectedServiceIds = couponMaster.eligible_service_plan_product?.service_category_ids || [];
    this.addServicessModal.next(true);
  }

  addPlans(couponMaster: OfferMaster) {
    this.couponMaster = couponMaster;
    this.couponMasterId = couponMaster.id;
    this.tenantId = couponMaster.tenant_id;
    this.selectedPlanIds = couponMaster.eligible_service_plan_product?.plan_ids || [];
    this.addPlansModal.next(true);
  }

  addOrganization(couponMaster: OfferMaster) {
    this.couponMaster = couponMaster;
    this.couponMasterId = couponMaster.id;
    this.tenantId = couponMaster.tenant_id;
    this.selectedOrganizationIds = couponMaster.eligible_organisations || [];
    this.addOrganisationModal.next(true);
  }

  closeEvent(event: any) {
    this.addClientsModal.next(false);
    this.addServicessModal.next(false);
    this.addPlansModal.next(false);
    this.selectedClients.next(event.selectedClients);
    if (event.reload) {
      this.columnData.subscribe({
        next: (data: any) => {
          this.onAction.emit({
            action: 'reload',
            columnData: data,
          });
        },
      });
    }
  }
}
